import {
  AuthenticationForm,
  AuthenticationFormVariants,
} from "../../components/AuthenticationForm";
import styles from "./styles.module.css";

interface Props {
  variant?: AuthenticationFormVariants;
}

export function AuthenticationScreen({
  variant = "default",
}: Props): JSX.Element {
  return (
    <div className={styles.pageBackground}>
      <div className={styles.formWrapper}>
        <AuthenticationForm variant={variant} />
      </div>
    </div>
  );
}
